import React, { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import SliderCom from "../../../Helpers/SliderCom";
import { getHeroBannerData } from "../../../../Services/service";
import ShareButton from "../../../ShareButton/ShareButton";

// import service from "../../../Services/service";
function Hero() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const settings = {
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    // asNavFor: ".hero-portal-active",
  };
  const portalSliderSettings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    // asNavFor: ".hero-slide-active",
    dots: false,
    centerMode: false,
    arrows: false,
    centerPadding: "0",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const [hdbanner, setHdbanner] = useState(null); 
  
  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const bd = await getHeroBannerData();
    setHdbanner(bd);  // Store only carousalData array in state
  }
  return(
    <>
    <div className="hero-slide-active">
  <SliderCom
    settings={settings}
    asNavFor={nav2}
    selector={(slider1) => setNav1(slider1)}
  >
    {hdbanner && hdbanner.carousalData.length >= 6 && (
      <div >
        <div>
          {/* Right: 5 Smaller Cards */}
          <div className="grid-wrapper">
            {hdbanner.carousalData.slice(0, 4).map((item) => (
              <Link to={`/News/${item.id}`} key={item.id}>
                <div className="grid-card"
                  style={{
                    backgroundImage: `url(${item.images})`,
                  }}
                >
                  <div className="binduz-er-hero-meta">
                      <div className="binduz-er-meta-category">
                        <a href="#">{item.news}</a>          
                      </div>
                      {/* <div className="binduz-er-meta-date">
                        <span>
                          <i className="fal fa-calendar-alt"></i> {item.date}
                        </span>
                      </div>
                      <div className="share">
                        <ShareButton open={`${item.id}`}/>
                      </div> */}
                    </div>
                    <div className="binduz-er-hero-title">
                      <h3 className="binduz-er-title">
                        <a href={`/News/${item.id}`}>
                        {item.title}
                        </a>
                      </h3>
                    </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    )}
    {hdbanner && hdbanner.carousalData.length >= 6 && (
      <div >
        <div>
          {/* Right: 5 Smaller Cards */}
          <div className="grid-wrapper">
            {hdbanner.carousalData.slice(4, 8).map((item) => (
              <Link to={`/News/${item.id}`} key={item.id}>
                <div className="grid-card"
                  style={{
                    backgroundImage: `url(${item.images})`,
                  }}
                >
                  <div className="binduz-er-hero-meta">
                      <div className="binduz-er-meta-category">
                        <a href="#">{item.news}</a>          
                      </div>
                      {/* <div className="binduz-er-meta-date">
                        <span>
                          <i className="fal fa-calendar-alt"></i> {item.date}
                        </span>
                      </div>
                      <div className="share">
                        <ShareButton open={`${item.id}`}/>
                      </div> */}
                    </div>
                    <div className="binduz-er-hero-title">
                      <h3 className="binduz-er-title">
                        <a href={`/News/${item.id}`}>
                        {item.title}
                        </a>
                      </h3>
                    </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    )}
        {hdbanner && hdbanner.carousalData.length >= 6 && (
      <div >
        <div>
          {/* Right: 5 Smaller Cards */}
          <div className="grid-wrapper">
            {hdbanner.carousalData.slice(8, 12).map((item) => (
              <Link to={`/News/${item.id}`} key={item.id}>
                <div className="grid-card"
                  style={{
                    backgroundImage: `url(${item.images})`,
                  }}
                >
                  <div className="binduz-er-hero-meta">
                      <div className="binduz-er-meta-category">
                        <a href="#">{item.news}</a>          
                      </div>
                      {/* <div className="binduz-er-meta-date">
                        <span>
                          <i className="fal fa-calendar-alt"></i> {item.date}
                        </span>
                      </div>
                      <div className="share">
                        <ShareButton open={`${item.id}`}/>
                      </div> */}
                    </div>
                    <div className="binduz-er-hero-title">
                      <h3 className="binduz-er-title">
                        <a href={`/News/${item.id}`}>
                        {item.title}
                        </a>
                      </h3>
                    </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    )}
  </SliderCom>
</div>
    </>
  )

  return (
    <>
      <div className="hero-slide-active">
        <SliderCom
          settings={settings}
          asNavFor={nav2}
          selector={(slider1) => setNav1(slider1)}
          >
    <div className="binduz-er-hero-area d-flex align-items-center">
              {hdbanner && hdbanner.carousalData.slice(0, 6).map((item) => {
                return (
                  <div className="container" >
              <div className="binduz-er-bg-cover" style={{ backgroundImage: `url(${item.image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: -1,
    opacity: 0.9, // adjust to your liking
    }}></div>
              <div className="row">
                <div className="col-lg-5 col-md-7">
                  <div className="binduz-er-hero-news-content">
                    <div className="binduz-er-hero-meta">
                      <div className="binduz-er-meta-category">
                        <a href="#">{item.news}</a>          
                      </div>
                      <div className="binduz-er-meta-date">
                        <span>
                          <i className="fal fa-calendar-alt"></i> {item.date}
                        </span>
                      </div>
                      <div className="share">
                        <ShareButton open={`${item.id}`}/>
                      </div>
                    </div>
                    <div className="binduz-er-hero-title">
                      <h3 className="binduz-er-title">
                        <a href={`/News/${item.id}`}>
                        {item.title}
                        </a>
                      </h3>
                    </div>
                    <div className="binduz-er-meta-author">
                      <div className="binduz-er-author">
                        <img
                          src={
                            require(`../../../../assets/images/user-1.png`)
                              .default
                          }
                          alt=""
                        />
                        <span>
                          <span>{item.author}</span>
                        </span>
                      </div>
                      {/* <div className="binduz-er-meta-list">
                        <ul>
                          <li>
                            <i className="fal fa-eye"></i> {item.view}
                          </li>
                          <li>
                            <i className="fal fa-heart"></i> {item.view}
                          </li>
                          <li>
                            <i className="fal fa-comments"></i> {item.view}
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-7">
                  <div className="binduz-er-hero-weather d-flex justify-content-end">
                    <div className="binduz-er-weather-item">
                      <img
                        src={
                          require(`../../../../assets/images/icon/icon-1.png`)
                            .default
                        }
                        alt=""
                      />
                      <h5 className="binduz-er-title">{item.state}</h5>
                      <span>{item.temp}</span>
                    </div>
                    <div className="binduz-er-weather-item">
                      <img
                        src={
                          require(`../../../../assets/images/icon/icon-2.png`)
                            .default
                        }
                        alt=""
                      />
                      <h5 className="binduz-er-title">{item.city}</h5>
                      <span>{item.temp}</span>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
                    )})}
          </div>


        </SliderCom>
      </div>
      <div className="hero-portal-area">
        <div className="binduz-er-hero-news-portal hero-portal-active">
          <SliderCom
            asNavFor={nav1}
            selector={(slider2) => setNav2(slider2)}
            settings={portalSliderSettings}
          >
            <div className="binduz-er-news-portal-item">
            {hdbanner && hdbanner.carousalData.slice(0, 1).map((item) => {
              return (
              <div className="binduz-er-news-portal-item-wrapped">
                <div className="binduz-er-thumb">
                  <a href="#">
                    {/* <img
                      src={
                        require(`../../../../assets/images/news-portal-1.jpg`)
                          .default
                      }
                      alt=""
                    /> */}
                    <Link to={`/News/${item.id}`}><img src={item.images} alt="" /></Link>
                  </a>
                </div>
                <div className="binduz-er-content">
                  <div className="binduz-er-post-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i> {item.date}
                    </span>
                  <div className="share">
                        <ShareButton open={`${item.id}`}/>
                  </div>
                      </div>
                  <h4 className="binduz-er-title">
                    <a href={`/News/${item.id}`}>
                    {item.title}
                    </a>
                  </h4>
                </div>
              </div>
                )})}
            </div>
            <div className="binduz-er-news-portal-item">
            {hdbanner && hdbanner.carousalData.slice(1,2).map((item) => {
              return (
              <div className="binduz-er-news-portal-item-wrapped">
                <div className="binduz-er-thumb">
                  <a href="#">
                    {/* <img
                      src={
                        require(`../../../../assets/images/news-portal-2.jpg`)
                          .default
                      }
                      alt=""
                    /> */}
                    <Link to={`/News/${item.id}`}><img src={item.images} alt="" /></Link>
                  </a>
                </div>
                <div className="binduz-er-content">
                  <div className="binduz-er-post-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i> {item.date}
                    </span>
                  <div className="share">
                        <ShareButton open={`${item.id}`}/>
                      </div>
                  </div>
                  <h4 className="binduz-er-title">
                    <a href={`/News/${item.id}`}>
                    {item.title}
                    </a>
                  </h4>
                </div>
              </div>
              )})}
            </div>
            <div className="binduz-er-news-portal-item">
            {hdbanner && hdbanner.carousalData.slice(2,3).map((item) => {
              return (
              <div className="binduz-er-news-portal-item-wrapped">
                <div className="binduz-er-thumb">
                  <a href="#">
                    {/* <img
                      src={
                        require(`../../../../assets/images/news-portal-3.jpg`)
                          .default
                      }
                      alt=""
                    /> */}
                    <Link to={`/News/${item.id}`}><img src={item.images} alt="" /></Link>
                  </a>
                </div>
                <div className="binduz-er-content">
                  <div className="binduz-er-post-meta-date">
                    <span>
                      <i className="fal fa-calendar-alt"></i> {item.date}
                    </span>
                    <div className="share">
                        <ShareButton open={`${item.id}`}/>
                      </div>
                  </div>
                
                  <h4 className="binduz-er-title">
                    <a href={`/News/${item.id}`}>
                    {item.title}
                    </a>
                  </h4>
                </div>
              </div>
              )})}
            </div>
          </SliderCom>
        </div>
      </div>
    </>
  );
}

export default Hero;
